import { render, staticRenderFns } from "./DuesList.vue?vue&type=template&id=0ff5b9ae"
import script from "./DuesList.vue?vue&type=script&lang=js"
export * from "./DuesList.vue?vue&type=script&lang=js"
import style0 from "./DuesList.vue?vue&type=style&index=0&id=0ff5b9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports